export const REGISTER_FORM_HOOKS = 'common/forms/register-form-hooks';
export const RELEASE_FORM_HOOKS = 'common/forms/release-form-hooks';

export const registerFormHooks = (handleSubmit, reset, dirty) => ({
    type: REGISTER_FORM_HOOKS,

    payload: {
        handleSubmit,
        reset,
        dirty,
    },
});

export const releaseFormHooks = () => ({
    type: RELEASE_FORM_HOOKS,
});
